import { render, staticRenderFns } from "./submitDialog.vue?vue&type=template&id=7e8f0234&scoped=true"
import script from "./submitDialog.vue?vue&type=script&lang=js"
export * from "./submitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8f0234",
  null
  
)

export default component.exports